var _PhotoShareCommand_instances, _PhotoShareCommand_createParam;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
import { SessionService } from '../../service/SessionService';
export class PhotoShareCommand {
    constructor() {
        _PhotoShareCommand_instances.add(this);
    }
    execute(photoUrl) {
        const url = 'https://mycast.xyz:8002/photo';
        axios.post(url, __classPrivateFieldGet(this, _PhotoShareCommand_instances, "m", _PhotoShareCommand_createParam).call(this, photoUrl));
    }
}
_PhotoShareCommand_instances = new WeakSet(), _PhotoShareCommand_createParam = function _PhotoShareCommand_createParam(photoUrl) {
    const privKey = SessionService.getPrivateKey();
    const params = new URLSearchParams();
    params.set('user', privKey);
    params.set('msg', photoUrl);
    return params.toString();
};
